<template>
  <router-view />
</template>

<style lang="scss">
@font-face {
  font-family: "taiwan";
  src: url("./assets/fonts/TaiwanPearlUPEP-Medium.ttf");
}

* {
  font-family: "taiwan";
}

body {
  margin: 0px;
}
.el-message--warning {
  font-size: 3vw;
}
</style>
